const MEGABYTES_IN_BYTES = 1024 * 1024;

export const fileSizeInMegabytes = (fileSize: number): number =>
  Math.floor(fileSize / MEGABYTES_IN_BYTES);

// takes in allowedFileTypes array for an upload type and turns it into the acceptedFileTypes
// value that Dropzone components accept
export const acceptedFileTypes = (allowedFileTypes?: string[]): string[] | undefined => {
  if (!allowedFileTypes || allowedFileTypes.includes('all')) {
    return;
  }

  return allowedFileTypes.map((type) => `.${type}`);
};
